<template>
	<div>

		<div class="container">
			<div class="logoBox">
				<div class="logoMark" style="padding: 10px;">
					<!--<div class="logoText">ATM</div>-->
					<img src="images/logo_atm.png" style="width: 100%;" />
				</div>
			</div>

			<div class="banner section">
				<div class="big"><span data-lang="t_22"></span><span
						style="color: aqua;">{{"#" + Number(userID).toString(16).toLocaleUpperCase()}}</span></div>
				<div class="big"><span data-lang="t_23"></span><span
						style="color: aqua;">{{"#" + Number(RefId).toString(16).toLocaleUpperCase()}}</span></div>
				<div class="small">
					<span class="big" style="color: azure;">{{userTitle}}：</span>
					<span style="color: #F00;font-size: 1.2rem;">{{userType}}</span><br>
					
					<span class="big" style="color: #0F0;">{{CaoJieShang}}</span>
				</div>
			</div>

			<div class="card section">
				<div class="row" style="padding:14px">
					<div>
						<div class="title" data-lang="t_24"></div>
						<div class="muted" ><div  @click="Announcement = 1" style="color: #FFF;font-size: 10;">ATM 新加坡百团领导人培训大会</div></div>

						<div class="muted" ><div  @click="Announcement = 3" style="color: #FFF;font-size: 10;">关于剩余创世节点投放公告</div></div>
						<div class="muted" ><div  @click="Announcement = 4" style="color: #FFF;font-size: 10;">关于ATM批量不规则账户惩罚公告</div></div>
						<div class="muted" ><div  @click="Announcement = 6" style="color: #FFF;font-size: 10;">重要通知：关于升级ATM 2.0版本</div></div>
						
						<div class="muted" ><div  @click="Announcement = 8" style="color: #FFF;font-size: 10;">恭喜比特龙基金会与 Deepro交易所达成战略合作</div></div>
						<div class="muted" ><div  @click="Announcement = 9" style="color: #FFF;font-size: 10;">创世节点价格调整公告</div></div>
						<div class="muted" ><div  @click="Announcement = 10" style="color: #F00;font-size: 10;">BTL上交易所公告</div></div>
						<div class="muted" ><div  @click="Announcement = 11" style="color: #FFF;font-size: 10;">与交易所技术对接公告</div></div>
					</div>
				</div>
			</div>

			<div class="card section">
				<div class="row" style="padding:14px 14px 0">
					<div class="h2" data-lang="t_27"></div>
					<span class="pill" data-lang="t_28"></span>
				</div>
				<div class="list" style="padding:14px">
					<TeamTreeNode v-for="item in teamData" :key="item.id" :node="item" />
				</div>
			</div>
		</div>

		<!-- 公告弹窗 -->
		<div class="modalMask" :class="{show:Announcement > 0}">
			<div class="modal">
				<div class="modalHead">
					<div>公告</div>
					<div class="modalClose" @click="Announcement = 0">×</div>
				</div>
				<div class="modalBody">
					<div v-if="Announcement == 1" class="reward_container">
						<div class="reward_title">ATM 新加坡百团领导人培训大会</div>
						
						<div class="reward_intro">
							2026年6月6日，新加坡将正式启动,百团领导人培训大会,本次会议面向核心团队长开放，具体要求如下：
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">参会资格</span>
								<span class="reward_desc">每位团队长需达成团队总业绩 60,000币（不含创世节点）</span>
							</div>
						
							<div class="reward_item">
								<span class="reward_level">达标团队长将获得：</span>
								<span class="reward_desc">
									<span class="reward_highlight">✅ 新加坡参会资格</span><br>	
									<span class="reward_highlight">✅ 官方报销当地住宿酒店费用</span>	
								</span>
								
							</div>
							<div class="reward_item">
								<span class="reward_level">🔹 创世节点发放规则</span>
								<span class="reward_desc">
									创世节点限量发行，分阶段投放：<br>
									第一个月：
									<span class="reward_highlight">限量 30个</span><br>
									第二个月：
									<span class="reward_highlight">限量 30个</span><br>
									第三个月：
									<span class="reward_highlight">全部售罄</span><br>
									未售出的创世节点
									<span class="reward_highlight">将统一打入黑洞地址销毁</span><br>
								</span>
							</div>
						
							<div class="reward_item">
								<span class="reward_level">大会核心机制</span>
								<span class="reward_desc">
									大会当天将完成以下重要动作：<br>
									<span class="reward_highlight" style="color: #F00;">创世节点没有推广30个有效用户，创世节点账户公司收回</span><br>
									<span class="reward_highlight">上一条收回完成后，所有合约全面开源</span><br>
									<span class="reward_highlight">永久丢弃所有权限</span><br>
									<span class="reward_highlight">实现全链路公开透明</span><br>
									<span class="reward_highlight">系统完全按照规则自动运行</span><br>
									
								</span>
							</div>
							
							<div class="reward_item">
								<span class="reward_level">VIP等级奖励机制（6月6日同步发放）</span>
								<span class="reward_desc">
									VIP2：
									<span class="reward_highlight">前30名奖励苹果 iPad 或等值 USDT</span><br>
									VIP3:  
									<span class="reward_highlight">前30名奖励20G纯金ATM限量版纪念币一枚</span><br>
									VIP4：
									<span class="reward_highlight">额外奖励 1 个创世节点（价值 60,000U）或者劳力士金表</span><br>
									VIP5：
									<span class="reward_highlight">奖励 玛莎拉蒂豪车 + 荣耀证书</span><br>
									（其他VIP等级奖励沿用既定方案执行）
								</span>
							</div>
							<div class="reward_item">
								<span class="reward_level">VIP等级奖励机制（6月6日同步发放）</span>
								<span class="reward_desc">
									<span class="reward_highlight">玛莎拉蒂豪华轿车</span><br>
									<span class="reward_highlight">2%的加权分红</span><br>
								</span>
							</div>
						</div>
						
						<div class="reward_call">** 立即行动，锁定您的专属奖励！</div>
						
						<div class="reward_contact" style="text-align: left;">
							<span class="reward_level">项目愿景：</span>
							ATM永续协议 致力于打造一个<br>
							👉 真实投资驱动的 10万人超级社区<br>
							<span class="reward_level">未来规划：</span>
							⛏ ATM挖矿结束后上线主流交易所（如 币安、欧易 等）<br>
							💰 设立 6000万美金流动性托底<br>
							🎁 按投资金额 1%空投比特龙（BTL）<br>
							<span class="reward_level">关于 BTL（比特龙）</span>
							总发行量：<span class="reward_highlight">999万枚</span><br>
							对标：<span class="reward_highlight">比特币</span><br>
							目标：<span class="reward_highlight">打造行业内第一大共识社区</span><br>
						</div>
						<div class="reward_footer">
							<div>宣发单位：新加坡比特龙ATM基金会万事达集团</div>
							<div class="reward_date">（公告日期：2026年03月19日）</div>
						</div>
					</div>
					
					<div  v-if="Announcement == 3"  class="reward_container">
						<div class="reward_title">关于剩余创世节点投放公告</div>
						<div class="reward_intro">
							尊敬的比特龙ATM社区会员：创世节点投放计划如下：
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">限量投放:</span>
								<span class="reward_desc"><span class="reward_highlight">30个创世节点</span></span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">3月19日~4月15日:</span>
								<span class="reward_desc"><span class="reward_highlight">限量投放:10个创世节点</span></span><br>
								<span class="reward_desc"><span class="reward_highlight">投放价格：15000 U</span></span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">4月16日~4月25日:</span>
								<span class="reward_desc"><span class="reward_highlight">限量投放:10个创世节点</span></span><br>
								<span class="reward_desc"><span class="reward_highlight">投放价格：20000 U</span></span><br>
								
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">4月26日~6月6日:</span>
								<span class="reward_desc"><span class="reward_highlight">限量投放:30个创世节点</span></span><br>
								<span class="reward_desc"><span class="reward_highlight">投放价格：30000 U</span></span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">剩余未投放:</span>
								<span class="reward_desc">6月6日后，全部打入黑洞</span><br>
							</div>
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">推荐要求:</span>
								<span class="reward_desc">推荐他人购买创世节点，需至少<span class="reward_highlight">3万U业绩作为担保</span></span><br>
							</div>
						</div>
						
						<div class="reward_footer">
							<div>新加坡比特龙ATM基金会(万事达集团)宣</div>
							<div class="reward_date">公告日期：2026年3月28日</div>
						</div>
					</div>
					<div  v-if="Announcement == 4"  class="reward_container">
						<div class="reward_title">关于ATM批量不规则账户惩罚公告</div>
						<div class="reward_intro">
							经平台AI系统检测，发现批量不规则账户，用脚本进行批量运作，饶过平台智能监管，已对一些不规则账户进行惩罚，为了平台的良好发展，请不要违规操作，一旦查明，永不解封，如果有疑问请联系官方处理。
						</div>
						
						
						<div class="reward_footer">
							<div>新加坡比特龙ATM基金会(万事达集团)宣</div>
							<div class="reward_date">公告日期：2026年4月24日</div>
						</div>
					</div>
					<div  v-if="Announcement == 5"  class="reward_container">
						<div class="reward_title" style="color: #0F0;">欢迎尊贵的超级商进入</div>
					</div>
					<div  v-if="Announcement == 6"  class="reward_container">
						<div class="reward_title"><span style="color: #F00;">重要通知：</span>关于升级ATM 2.0版本</div>
						<div class="reward_intro">
							为了全球市场的长久、稳定及持续发展，万事达集团与比特龙ATM基金会一致决定，合作推出ATM 2.0升级系统。具体规则调整如下：
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">1. ATM大厅交易规则</span>
								<span class="reward_desc">ATM大厅自由挂卖，<span class="reward_highlight">40%交易流水</span>将进入交互池。</span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">2. C2C交易收益</span>
								<span class="reward_desc">C2C交易<span class="reward_highlight">90%收益</span>规则保持不变。</span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">3. BTL空投比例调整</span>
								<span class="reward_desc">为回馈广大会员，比特龙（BTL）<span class="reward_highlight">空投从原来的1%调整为2%。</span></span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">4. 超级商政策</span>
								<span class="reward_desc">为促进全球社区良性发展，全球统一执行超级商35:65，规则及原有政策不变,凡破坏平台规则者，一经核实，永久封号。</span>
							</div>
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								
								<span class="reward_desc"><span class="reward_highlight">特此通知，请全球社区成员相互转告。</span></span>
							</div>
						</div>
						
						<div class="reward_footer">
							<div>新加坡比特龙ATM基金会(万事达集团)宣</div>
							<div class="reward_date">公告日期：2026年5月3日</div>
						</div>
					</div>
					<div  v-if="Announcement == 8"  class="reward_container">
						
						<div class="reward_title">恭喜比特龙基金会与 Deepro交易所达成战略合作</div>
						<div class="reward_intro">
							新加坡比特龙基金会与盈证国际控股集团旗下Deepro交易所已达成战略合作，目前正在实施BTL代币上交易所准备事宜。
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">一 、恢复交易</span>
								<span class="reward_desc"><span class="reward_highlight">打通技术需要一周，也就是至2026年5月24日，给大家带来不便，敬请谅解</span></span>
							</div>
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">二 、ATM与BTL兑换功能</span>
								<span class="reward_desc"><span class="reward_highlight">BTL上市后，将会开启ATM与BTL兑换通道。</span></span>
							</div>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">三 、Deepro交易所网址</span>
								<span class="reward_desc"><span class="reward_highlight">https://www.deepro.com</span></span><br>
								<span class="reward_desc"><span class="reward_highlight">请于3日后下载Deepro交易所，查看交易所公告</span></span>
							</div>
						</div>
						<div class="reward_list">
							<img src="images/deepro.jpg" style="width: 100%;"/>
						</div>
						<div class="reward_list">
							<img src="images/deepro1.jpg" style="width: 100%;"/>
						</div>
						<div class="reward_list">
							<div class="reward_item">
								
								<span class="reward_desc"><span class="reward_highlight">特此通知，请全球社区成员相互转告。</span></span>
							</div>
						</div>
						
						<div class="reward_footer">
							<div>新加坡比特龙ATM基金会(万事达集团)宣</div>
							<div class="reward_date">公告日期：2026年5月17日 00:00:00</div>
						</div>
					</div>
					
					<div  v-if="Announcement == 9"  class="reward_container">
						
						<div class="reward_title">创世节点价格调整公告</div>
						<div class="reward_intro">
							经新加坡比特龙ATM基金会研究决定，ATM创世节点价格即将调整
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">调整时间</span>
								<span class="reward_desc"><span class="reward_highlight">2026年5月29日</span></span>
							</div>
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">调整后价格</span>
								<span class="reward_desc"><span class="reward_highlight">每个创世节点50000USDT</span></span>
							</div>
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								
								<span class="reward_desc"><span class="reward_highlight">特此通知，请全球社区成员相互转告。</span></span>
							</div>
						</div>
						
						<div class="reward_footer">
							<div>新加坡比特龙ATM基金会(万事达集团)宣</div>
							<div class="reward_date">公告日期：2026年5月24日</div>
						</div>
					</div>
					<div  v-if="Announcement == 10"  class="reward_container">
						
						<div class="reward_title">BTL上交易所公告</div>
						<div class="reward_intro">
							Deepro交易所将于2026年5月29日20:00(UTC+8)上线BTL/USDT交易对，请大家提前下载交易所APP
						</div>
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">上所时间</span>
								<span class="reward_desc"><span class="reward_highlight">2026年5月29日 20:00</span></span>
							</div>
						</div>
						
						<div class="reward_list">
							<div class="reward_item" @click="copyAddress('https://deepro.zendesk.com/hc/zh-cn/articles/16227568378511')">
								<span class="reward_level">中文网址</span>
								<span class="reward_desc"><span class="reward_highlight">https://deepro.zendesk.com/hc/zh-cn/articles/16227568378511(点击可复制)</span></span>
							</div>
						</div>
						<div class="reward_list" @click="copyAddress('https://deepro.zendesk.com/hc/en-us/articles/16227568378511')">
							<div class="reward_item">
								<span class="reward_level">英文网址</span>
								<span class="reward_desc"><span class="reward_highlight">https://deepro.zendesk.com/hc/en-us/articles/16227568378511(点击可复制)</span></span>
							</div>
						</div>
						
						
						<div class="reward_list">
							<span class="reward_level">推荐网址</span>
							<span class="reward_desc"><span class="reward_highlight">请大家抓紧扫码注册，不要影响兑换，持币生息和交易挖矿BTL</span></span>
							<img src="images/deepro_2.jpg" style="width: 100%;"/>
						</div>
						<div style="width: 100%;height: 2px;background-attachment: #AAA;"></div>
						
						<div class="reward_list">
							<div class="reward_item">
								
								<span class="reward_desc"><span class="reward_highlight">特此通知，请全球社区成员相互转告。</span></span>
							</div>
						</div>
						
						<div class="reward_footer">
							<div>新加坡比特龙ATM基金会(万事达集团)宣</div>
							<div class="reward_date">公告日期：2026年5月24日</div>
						</div>
					</div>
					
					<div  v-if="Announcement == 11"  class="reward_container">
						
						<div class="reward_title">与交易所技术对接公告</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level"></span>
								<span class="reward_desc"><span class="reward_highlight">各位尊贵的atm会员，由于与交易所技术对接，为了避免资产丢失，29号之前禁止操作（挖矿、交易）</span></span>
							</div>
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								<span class="reward_level">新功能上线</span>
								<span class="reward_desc"><span class="reward_highlight">对接完成后，同时会有利好创世节点的新功能上线</span></span>
							</div>
						</div>
						
						<div class="reward_list">
							<div class="reward_item">
								
								<span class="reward_desc"><span class="reward_highlight">特此通知，请全球社区成员相互转告。</span></span>
							</div>
						</div>
						
						<div class="reward_footer">
							<div>新加坡比特龙ATM基金会(万事达集团)宣</div>
							<div class="reward_date">公告日期：2026年5月27日</div>
						</div>
					</div>
					
				</div>
				<div class="modalFoot">
					<button class="btn" @click="Announcement = 0">关闭</button>
				</div>
			</div>
		</div>

		<!-- Bottom Nav -->
		<div class="bottom">
			<div class="bottom-inner">
				<div class="nav active">
					<i class="fas fa-home"></i>
					<span data-lang="t_2"></span>

				</div>
				<div class="nav" data-lang="t_3"></div>
				<div class="nav" data-lang="t_4"></div>
				<div class="nav" data-lang="t_5"></div>
			</div>
		</div>
	</div>


</template>

<script>
	import TeamTreeNode from './child/TeamTreeNode.vue'
	export default {
		name: 'Home',
		components: {
			TeamTreeNode
		},
		data() {
			return {
				userID: 0,
				RefId: 0,
				userTitle: "",
				userType: "",
				teamData: [],
				Announcement: 0, //公告
				CaoJieShang:"",
			}
		},
		mounted() {
			
			this.showUI();
		},
		methods: {
			setLanguage() {
				const elements = document.querySelectorAll('[data-lang]');

				elements.forEach(element => {
					const langValue = element.getAttribute('data-lang');

					element.innerHTML = Lang[lg][langValue];
				});
			},
			copyAddress(text){
				copyRefURL(text);
				
			},
			async showUI() {
				//判断是否是超级商
				let cjs = await conCao.getCaoJieShang(Account).call();
				if(cjs)this.CaoJieShang = "尊贵的超级商";
				if(IsShowAnnouncement == true){
					IsShowAnnouncement = false;
					//如果是超级商，就显示超级商，否则显示2号公告
					if(cjs)this.Announcement=10//8//5;
					else 
						this.Announcement = 10//8//7;
				}
				this.setLanguage();
				const user = await conMine.getPeopleTree(Account).call();
				
				this.userID = user.id //Number(user.id).toString(16);
				this.RefId = user.fatherNode //Number(user.fatherNode).toString(16);
				
				if (user.Type == 1) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_3;
				} else if (user.Type == 2) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_33;
				} else if (user.Type == 3 || user.Type == 11) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_34;
				} else if (user.Type == 4 || user.Type == 12) {
					this.userTitle = Lang[lg].t_405;
					this.userType = Lang[lg].t_35;
				}
				await Sleep(this.$waitTime);
				const child = await conMine.GetBrother(user.childNode, 100).call();

				if (child == null) return;
				const len = child.length;
				let point = 2;

				let index = 0;
				let team = [];
				while (point < len) {
					team[index] = {};
					team[index].id = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].people = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].totalMine = Number("0x" + child.substring(point, point + 8));
					point += 8;
					team[index].leval = Number("0x" + child.substring(point, point + 2));
					point += 2;
					team[index].quickenFloor = Number("0x" + child.substring(point, point + 2));
					point += 2;
					team[index].children = []; // 存储下级数据
					team[index].expanded = false; // 控制是否展开
					team[index].id = team[index].id.toString(16).toLocaleUpperCase(); //转换成16进制
					index++;
				}
				this.teamData = team;
			},
		},
	}
</script>
<style>
	.reward_container {

		color: #ffffff;
		font-family: 'Microsoft YaHei', 'Segoe UI', sans-serif;

		max-width: 800px;
		line-height: 1.7;

	}

	.reward_title {
		color: #00ffff;
		text-align: center;
		font-size: 1.5rem;
		margin-bottom: 6px;
		padding-bottom: 12px;
		border-bottom: 2px solid rgba(0, 255, 255, 0.3);
		text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
		letter-spacing: 2px;
	}

	.reward_intro {
		color: #cccccc;
		font-size: 0.8rem;
		margin-bottom: 25px;
		text-align: left;
		padding: 0 10px;
	}

	.reward_list {
		margin: 10px 0;
		padding-left: 0;
	}

	.reward_item {
		background: linear-gradient(90deg, rgba(0, 255, 255, 0.05), rgba(0, 255, 255, 0.02));
		border-left: 4px solid #00ffff;
		margin-bottom: 5px;
		padding: 6px 12px;
		border-radius: 0 8px 8px 0;
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
		text-align: left;
	}

	.reward_item::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		height: 100%;
		width: 0;
		background: linear-gradient(90deg, rgba(0, 255, 255, 0.1), transparent);
		transition: width 0.5s ease;
		/* 【关键修复】让伪元素不响应鼠标事件，穿透点击到底层元素 */
		    pointer-events: none; 
		    z-index: 0; /* 确保它在内容之下 */
	}

	.reward_item:hover::before {
		width: 100%;
	}

	.reward_item:hover {
		transform: translateX(5px);
		box-shadow: 0 5px 15px rgba(0, 255, 255, 0.1);
	}

	.reward_level {
		color: #00ffff;
		font-weight: bold;
		font-size: 0.85rem;
		margin-bottom: 8px;
		display: block;
	}

	.reward_desc {
		color: #e0e0e0;
		font-size: 0.75rem;
		
	}

	.reward_highlight {
		color: #ffcc00;
		font-weight: bold;
		text-shadow: 0 0 5px rgba(255, 204, 0, 0.3);
	}

	.reward_call {
		text-align: center;
		font-size: 1.0rem;
		font-weight: bold;
		color: #00ffaa;
		margin: 6px 0;
		padding: 6px;
		background: rgba(0, 255, 170, 0.08);
		border-radius: 10px;
		border: 1px solid rgba(0, 255, 170, 0.2);
		animation: pulse 2s infinite;
	}

	@keyframes pulse {
		0% {
			box-shadow: 0 0 0 0 rgba(0, 255, 170, 0.4);
		}

		70% {
			box-shadow: 0 0 0 10px rgba(0, 255, 170, 0);
		}

		100% {
			box-shadow: 0 0 0 0 rgba(0, 255, 170, 0);
		}
	}

	.reward_contact {
		color: #aaaaaa;
		font-size: 0.7rem;
		text-align: center;
		margin: 6px 0;
		padding: 6px;
		background: rgba(255, 255, 255, 0.03);
		border-radius: 6px;
	}

	.reward_footer {
		font-size: 0.6rem;
		color: #888888;
		text-align: center;
		margin-top: 12px;
		padding-top: 6px;
		border-top: 1px solid #333333;
	}

	.reward_date {
		color: #999999;
		font-style: italic;
		margin-top: 5px;
	}
</style>